import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
